import { render } from "./HomeBan.vue?vue&type=template&id=3f1c46da&scoped=true"
import script from "./HomeBan.vue?vue&type=script&lang=js"
export * from "./HomeBan.vue?vue&type=script&lang=js"

import "./HomeBan.vue?vue&type=style&index=0&id=3f1c46da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f1c46da"]])

export default __exports__